'use client';

export default function HeroSection() {
  return (
    <section
      className="relative min-h-screen flex items-center justify-center px-5 md:px-8 pt-24 pb-16 overflow-hidden bg-gradient-to-br from-primary via-primary/95 to-primary/90"
    >
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)', backgroundSize: '40px 40px' }} />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-6">
          <span className="w-2 h-2 rounded-full bg-white animate-pulse" />
          <span className="text-xs font-bold text-white uppercase tracking-wider">Built for Serious Online Coaches</span>
        </div>

        {/* Headline */}
        <h1 className="display-xl text-white mb-6 leading-tight">
          Install AI Assistants Into
          <br />
          Your Coaching Business.
          <br />
          <span className="text-white/80">Scale Without Hiring.</span>
        </h1>

        <p className="text-xl md:text-2xl text-white/90 mb-10 max-w-3xl mx-auto leading-relaxed">
          ElevateX installs four AI Assistants that automate onboarding, programming, check-in reminders, and weekly reviews — so you focus on coaching, not admin.
        </p>

        {/* CTA */}
        <div className="flex flex-col items-center justify-center gap-3">
          <a
            href="#waitlist"
            className="btn-secondary text-base px-8 py-4 inline-block shadow-xl hover:shadow-2xl"
            style={{ fontWeight: 700 }}
          >
            Book Your Strategy Call →
          </a>
          <p className="text-white/70 text-sm font-medium">
            Built for coaches managing 15+ active clients.
          </p>
        </div>
      </div>
    </section>
  )
}